import { render, staticRenderFns } from "./VueEchart.vue?vue&type=template&id=05d16e99&"
import script from "./VueEchart.vue?vue&type=script&lang=js&"
export * from "./VueEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports